<template>
  <div class="navbar">
    <div class="navbar-end">
      <div v-if="isTopMenu" class="navbar-item top-menu">
        <div class="buttons flex-end">
          <router-link :to="{ name: 'server' }">
            <span
              ><b>{{ server_name }}</b></span
            >
          </router-link>
          <router-link :to="{ name: 'models' }">
            <span>{{ $t('server.models.title') }}</span>
          </router-link>
          <router-link :to="{ name: 'sources' }">
            <span>{{ $t('server.sources.title') }}</span>
          </router-link>
          <router-link :to="{ name: 'pipelines' }">
            <span>{{ $t('server.pipelines.title') }}</span>
          </router-link>
          <router-link :to="{ name: 'mergers' }">
            <span>Merging</span>
          </router-link>
          <router-link :to="{ name: 'outputs' }">
            <span>{{ $t('server.outputs.title') }}</span>
          </router-link>
        </div>
      </div>
      <div class="navbar-item">
        <popup :open.sync="notificationsIsOpen" :title="$t('title.notifications')">
          <template slot="default">
            <notifications :notifications="notifications" @close="close"></notifications>
          </template>

          <template slot="footer">
            <button class="button" @click="closeAll">Close all</button>
          </template>
        </popup>
        <div class="buttons flex-end">
          <button
            class="button"
            @click="notificationsIsOpen = true"
            :class="{ 'show-notification-badge': hasNotifications }"
          >
            <span class="icon is-small">
              <i class="far fa-bell"></i>
            </span>
          </button>
          <a @click="logout" class="logout button is-rounded is-link">
            {{ $t('button.logout') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from './Notifications'
import { mapActions, mapGetters } from 'vuex'
import Popup from './Popup'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapUserState } = createNamespacedHelpers('general')
import { mapState } from 'vuex'
export default {
  name: 'Navbar',
  components: { Popup, Notifications },
  data() {
    return {
      notificationsIsOpen: false,
      notifications: [],
      serversLoading: false
    }
  },
  computed: {
    ...mapState(['socket']),
    ...mapGetters('general', ['userHasAlarm']),
    ...mapUserState({
      server_name: state => state.server_name,
      stateUser: state => {
        return state.user
      }
    }),
    hasNotifications() {
      return this.notifications && this.notifications.length > 0
    },
    isTopMenu() {
      return [
        'models',
        'pipelines',
        'pipeline',
        'mergers',
        'merge',
        'add_merge',
        'sources',
        'add_source',
        'source',
        'outputs',
        'add_output',
        'output'
      ].includes(this.$router.history.current.name)
    }
  },
  mounted() {
    this.$options.sockets.onmessage = message => {
      let data = JSON.parse(message.data)
      if (data.method === 'update_notifications') {
        const notifications = data.notifications.map(el => {
          return this.formatNotification(el)
        })
        this.notifications = this.$lodash.sortBy(notifications, ['id'])
      } else if (data.method === 'add_notifications') {
        const notifications = data.notifications.map(el => {
          if (this.userHasAlarm(el.type)) {
            const type = this.colorToType(el.color)
            const msg = el.message
            const timeout = el.timeout || Infinity
            this.$notify({
              message: `${this.$t('notification.message', { msg })}`,
              type,
              id: el.id,
              timeout,
              onClose: id => {
                if (timeout === Infinity) {
                  this.close(id)
                }
              }
            })
          }
          return this.formatNotification(el)
        })
        this.notifications = [...notifications, ...this.notifications]
      }
    }
    this.fetchPendingNotifications()
    this.subscribe()
  },
  methods: {
    ...mapActions(['sendMessage', 'subscribedSocket']),
    ...mapActions('general', ['clearUser']),
    formatNotification(notification) {
      return {
        id: notification.id,
        message: notification.message,
        type: notification.type,
        notification_type: this.colorToType(notification.color)
      }
    },
    subscribe() {
      const vm = this
      setTimeout(() => {
        if (!this.socket.isConnected && !this.socket.reconnectError) {
          vm.subscribe()
        } else if (this.socket.isConnected && !this.socket.isSubscribed) {
          vm.sendMessage(JSON.stringify({ method: 'subscribe', login: this.stateUser.login }))
          vm.subscribedSocket(true)
        }
      }, 1000)
    },
    fetchPendingNotifications() {
      if (!this.serversLoading) {
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/notification/pending`
        this.serversLoading = true
        return fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.notifications = data.map(el => {
              return this.formatNotification(el)
            })
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    close(id) {
      if (!this.serversLoading) {
        const body = {
          message_id: id
        }
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/notification/close`
        this.serversLoading = true
        return fetch(url, {
          credentials: 'include',
          body: JSON.stringify(body),
          method: 'POST'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
            this.fetchPendingNotifications()
          })
      }
    },
    closeAll() {
      if (!this.serversLoading) {
        const body = {}
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/notification/close`
        this.serversLoading = true
        return fetch(url, {
          credentials: 'include',
          body: JSON.stringify(body),
          method: 'POST'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
            this.fetchPendingNotifications()
          })
      }
    },
    logout() {
      fetch(`${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/logout`, {
        method: 'get',
        credentials: 'include'
      })
        .then(() => {
          this.clearUser()
          this.$router.push('/login')
        })
        .catch(err => {
          this.$notify({
            message: err,
            type: 'danger'
          })
        })
    },
    colorToType(color) {
      switch (color) {
        case 'red':
          return 'danger'
        case 'yellow':
          return 'warning'
        case 'green':
          return 'success'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.navbar {
  background-color: #1c2b36 !important;
}
.navbar-end {
  float: right;
  margin: 0.3rem;
  width: 100%;
  .logout {
    float: right;
  }
  .top-menu {
    width: 100%;
    .flex-end {
      margin-left: 22rem;
      a {
        color: white;
        margin-left: 1rem;
        font-size: 1rem;
        &:hover {
          color: #3273dc;
        }
      }
    }
  }
}
.flex-end {
  display: flex;
  justify-content: flex-end;
}
.show-notification-badge {
  position: relative;
  &:before {
    content: '';
    position: absolute;
    right: 3px;
    top: 3px;
    min-width: 0.5rem;
    min-height: 0.5rem;
    border-radius: 50%;
    background: #ff3860;
  }
}
</style>
